/**
 * 项目图片地址：线上 CDN，本地开发映射到 h5Img 目录
 * 本地目录：D:\workspace\dajiuxing\h5Img\large-images-over-2mb\referenced-for-cdn
 * 由 webpack-dev-server 挂载为 /h5-large-img/
 *
 * 路径参数为相对 src 的路径，例如：
 * assets/img/chineseMedicine/reportInterpretation.png
 *
 * 说明：通过 require/import/@/assets 引入的 png/jpg/gif/webp/bmp
 * 已由 webpack ExternalImgPlugin 自动改写；本工具用于字符串拼 URL 的场景。
 */

/** 线上图片 CDN 根路径 */
export const LARGE_IMG_CDN_BASE = 'https://health.dajiuxing.com.cn/img'

/** 本地开发静态映射路径（见 build/webpack.dev.conf.js） */
export const LARGE_IMG_LOCAL_BASE = '/h5-large-img'

/**
 * 是否本地开发访问
 * @returns {boolean}
 */
function isLocalDev() {
  if (process.env.NODE_ENV === 'development') return true
  if (typeof window === 'undefined') return false
  const host = window.location.hostname || ''
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '0.0.0.0' ||
    /^192\.168\.\d+\.\d+$/.test(host) ||
    /^10\.\d+\.\d+\.\d+$/.test(host) ||
    /^172\.(1[6-9]|2\d|3[0-1])\.\d+\.\d+$/.test(host)
  )
}

/**
 * 获取图片完整 URL
 * @param {string} srcRelativePath 相对 src 的路径，如 assets/login/xxx.png
 * @returns {string}
 */
export function getLargeImgUrl(srcRelativePath) {
  const name = String(srcRelativePath || '').replace(/^\/+/, '').replace(/\\/g, '/')
  if (!name) return ''
  const base = isLocalDev() ? LARGE_IMG_LOCAL_BASE : LARGE_IMG_CDN_BASE
  return base.replace(/\/+$/, '') + '/' + name
}



// WEBPACK FOOTER //
// ./src/utils/largeImgUrl.js